/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";
import { isGuid } from "utils/empty-exists";
import { useAuth } from "cms/auth/hooks/use-auth";
import { TimelineImage } from "./timeline-image";

const TimelineItem = (props) => {
    const { timelineItem } = props;
    const { image: timelineImage, milestone, timeframe } = timelineItem || {};
    const { image: image_guid } = timelineImage || {};

    const { token } = useAuth();
    const [image, setImage] = useState();

    useEffect(() => {
        const fetchImage = async () => {
            if (!image) {
                if (image_guid && isGuid(image_guid)) {
                    const img = await SimpliCityAdminSDK.image.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetchImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, image_guid]);

    return (
        <div className='timeline-item'>
            {milestone && <p>{milestone}</p>}
            {timeframe && <h3>{timeframe}</h3>}
            {image && <TimelineImage image={image} />}
        </div>
    );
};

TimelineItem.displayName = "TimelineItem";
export { TimelineItem };
